import axios from 'axios'
import store from '../store'
// import VueCookie from 'vue-cookie'
// import { Message} from 'iview'
// import api from './api'
axios.defaults.timeout = 50000

// axios.defaults.baseURL = '/api/webtest/'
axios.defaults.baseURL = '/api/web/'

axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded'
// axios.defaults.headers.post['csrftoken'] = VueCookie.get('csrftoken')

// http request 拦截器
axios.interceptors.request.use(
  config => {
    // config.headers.post['csrftoken'] = VueCookie.get('csrftoken')
    // store.commit('loading', {
    //   bool: true
    // })
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
// const basePath = require('../../config/basePath')
// http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response) {
      // setTimeout(() => {
      //   store.commit('loading', { bool: false })
      // }, 100)
    }

    return response
  },
  error => {
    // setTimeout(() => {
    //   store.commit('loading', { bool: false })
    // }, 300)
    if (error.response) {
      // switch (error.response.status) {
      //   case 401:
      //     if (error.response.data.indexOf('jumpto') == -1) {
      //         location.href = error.response.data + '&jumpto=' + location.href
      //     } else {
      //       location.href = error.response.data
      //     }
      //     break
      //   // case 411:
      //   //   api.base
      //   //     .logout({
      //   //       jumpto: location.origin + `/${basePath}/`
      //   //     })
      //   //     .then(res => {
      //   //       location.href = res.data
      //   //     })
      //   case 502:
      //     Message.error('服务未响应！')
      //     break
      // }
    }
    return Promise.reject(error)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/api/http.js